import React, { forwardRef } from "react";
import { Form } from "react-bootstrap";
import { Controller } from "react-hook-form";
import { FaChevronDown } from "react-icons/fa";

const ThemeSelect = forwardRef((props, ref) => {
  const {
    name,
    control,
    errors,
    rules = {},
    label = "",
    disabled = false,
    isLabel = false,
    className = "",
    labelClassName,
    options = [],
    placeholder,
  } = props;

  return (
    <div className={`${className}`}>
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({ field }) => (
          <>
            {isLabel ? (
              <Form.Label className={labelClassName}>{label}</Form.Label>
            ) : (
              ""
            )}
            <div className="select-wrapper">
              <Form.Control
                {...field}
                as="select"
                disabled={disabled || false}
                value={field.value || ""}
                onChange={field.onChange}
                placeholder={field.placeholder}
              >
                <option value={placeholder} className="">{placeholder}</option>
                {options?.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Form.Control>
              <FaChevronDown className="dropdown-icon" />
            </div>
          </>
        )}
      />
      {errors[name] && (
        <span className="text-red validation-txt">{errors[name].message}</span>
      )}
    </div>
  );
});

ThemeSelect.displayName = "ThemeSelect";

export default ThemeSelect;
